var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.unreadCount)?_c('div',{staticClass:"chat-unread-indicator"},[_vm._v(_vm._s(_vm.unreadCount))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }